import DropdownFilter from '../ui/DropdownFilter/DropdownFilter'
import styles from './CareerLayout.module.scss'

function CareerFilters({
  locationFilter,
  functionFilter,
  selectedFilter,
  handleFilterChange,
}) {
  return (
    <>
      {selectedFilter.selectedlocation && (
        <DropdownFilter
          title={locationFilter?.label}
          options={locationFilter?.list}
          selectedOption={selectedFilter?.selectedlocation}
          selectedOptionKey={'selectedlocation'}
          handleChange={handleFilterChange}
          disabled={locationFilter?.lists?.length === 1}
          className={styles.filters}
          height={28}
        />
      )}
      {selectedFilter.selectedFunction && (
        <DropdownFilter
          title={functionFilter?.label}
          options={functionFilter?.list}
          selectedOption={selectedFilter?.selectedFunction}
          selectedOptionKey={'selectedFunction'}
          handleChange={handleFilterChange}
          disabled={functionFilter?.list?.length === 1}
          className={styles.filters}
          height={28}
        />
      )}
    </>
  )
}

export default CareerFilters
